module.exports = __webpack_public_path__ + "static/media/STPProjectPreview1870@2x.a39a9c9a.jpg";